var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.395,
    height: 188.482,
    viewBox: "0 0 192.395 188.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-972.303 -500.76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(982.211 500.76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.207,90.54c-18.173-27.827-16.241-56.35-25-69.761s-34.866-36.533-96.55,3.758S-.339,108.626,9.3,123.373C54.411,192.433,199.4,139.821,167.207,90.54Z",
    transform: "translate(-0.134 -1.91)",
    fill: "#f8f8f8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(991.736 502.146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H4.805V9.61H0Z",
    transform: "translate(0 3.397) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H9.61V4.805H0Z",
    transform: "translate(0 6.794) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.534 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H9.61V4.805H0Z",
    transform: "translate(0 6.794) rotate(-45)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.91 138.616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.958,41.165a7.208,7.208,0,1,1,7.208-7.208A7.217,7.217,0,0,1,33.958,41.165Zm0-9.61a2.4,2.4,0,1,0,2.4,2.4A2.407,2.407,0,0,0,33.958,31.555Z",
    transform: "translate(-26.75 -26.75)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.198,
    cy: 7.844,
    rx: 96.198,
    ry: 7.844,
    transform: "translate(972.303 673.553)",
    fill: "#f5f5f5",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1023.289 543.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11044.792-4092.692l10.429-56.5h19.332l1.313,5.933h40.641l-9.4,50.568Z",
    transform: "translate(-11035.716 4170.067)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.846,110.837l-1.968,9.53-1.267-1.236-2.155,1.538-1.647-2.046-3.693,2.685-3.156-5.278-3.52,2.062-1.4-1.925-4.47,2.519-1.345-2.881,3.133-15.176,16.8,3.469Z",
    transform: "translate(-512.181 -91.398)",
    fill: "#efeff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.753,117.5l4.684,6.738-5.827-1.2Z",
    transform: "translate(-584.773 -104.799)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.772,188.268l-2.885,13.982-22.628-4.671,2.864-13.868,1.345,2.879,4.472-2.519,1.394,1.925,3.522-2.06,3.154,5.278,3.695-2.685,1.645,2.044,2.157-1.536Z",
    transform: "translate(-499.495 -157.396)",
    fill: "#efeff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.661,84.964,378.6,86.391l-1.832-29.6,17.123-1.061L400.179,61Z",
    transform: "translate(-376.77 -55.73)",
    fill: "#efeff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.05,55.73,466.336,61l-5.938.368Z",
    transform: "translate(-442.927 -55.73)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,103.06l-.09-.668a5.927,5.927,0,0,1,1.349-4.55c1.086-1.439,1.674-2.467,1.608-3.635-.074-1.316-.948-2.147-2.574-2.081a4.587,4.587,0,0,0-2.56.946l-.709-1.589a6.732,6.732,0,0,1,3.629-1.234c2.967-.164,4.41,1.591,4.523,3.551.1,1.754-.81,3.072-1.966,4.612a5.1,5.1,0,0,0-1.258,3.872l.064.67Zm-.366,3.641a1.526,1.526,0,0,1,1.456-1.711,1.615,1.615,0,1,1-1.464,1.711Z",
    transform: "translate(-406.758 -83.143)",
    fill: "#dfdff0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.286,233.572H271.64L280.7,182.2h62.646Z",
    transform: "translate(-262.499 -176.879)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.131,156.32h-20.5l-.94,5.321h21.941Z",
    transform: "translate(-297.491 -156.32)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,159.969a3.942,3.942,0,0,1,0-1.789A3.942,3.942,0,0,1,309.1,159.969Z",
    transform: "translate(-292.177 -157.798)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.176,163.466a3.5,3.5,0,0,1-.537-.724,3.568,3.568,0,0,1-.36-.822,3.408,3.408,0,0,1,.537.722A3.621,3.621,0,0,1,297.176,163.466Z",
    transform: "translate(-282.072 -160.769)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.258,172.634a3.943,3.943,0,0,1-1.548-.894,3.528,3.528,0,0,1,.822.358A3.615,3.615,0,0,1,288.258,172.634Z",
    transform: "translate(-274.47 -168.569)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.089,184.653a3.941,3.941,0,0,1-1.789,0A3.942,3.942,0,0,1,285.089,184.653Z",
    transform: "translate(-271.761 -178.746)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.626,193.91a3.626,3.626,0,0,1-.724.537,3.53,3.53,0,0,1-.822.358,3.494,3.494,0,0,1,.724-.537A3.453,3.453,0,0,1,288.626,193.91Z",
    transform: "translate(-274.764 -186.181)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.784,200.3a3.933,3.933,0,0,1-.894,1.55,3.461,3.461,0,0,1,.36-.822A3.56,3.56,0,0,1,297.784,200.3Z",
    transform: "translate(-282.557 -191.257)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.8,202.51a3.588,3.588,0,0,1,.1.894,3.5,3.5,0,0,1-.1.894,3.407,3.407,0,0,1-.1-.894A3.588,3.588,0,0,1,309.8,202.51Z",
    transform: "translate(-292.731 -193.013)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,199.984a3.5,3.5,0,0,1,.537.724,3.455,3.455,0,0,1,.358.822,3.933,3.933,0,0,1-.894-1.55Z",
    transform: "translate(-300.168 -191.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.45,193.3a3.453,3.453,0,0,1,.822.358,3.494,3.494,0,0,1,.724.537,3.455,3.455,0,0,1-.822-.358A3.494,3.494,0,0,1,325.45,193.3Z",
    transform: "translate(-305.245 -185.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66,183.943a3.952,3.952,0,0,1,1.791,0A3.952,3.952,0,0,1,327.66,183.943Z",
    transform: "translate(-307 -178.182)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.084,172.024a3.559,3.559,0,0,1,.724-.535,3.38,3.38,0,0,1,.822-.36,3.934,3.934,0,0,1-1.55.894Z",
    transform: "translate(-304.951 -168.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,163.116a3.615,3.615,0,0,1,.358-.822,3.5,3.5,0,0,1,.537-.724,3.454,3.454,0,0,1-.358.822A3.5,3.5,0,0,1,318.45,163.116Z",
    transform: "translate(-299.684 -160.491)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.875,240.777H236.1L227.18,191.27h62.781Z",
    transform: "translate(-227.18 -184.084)",
    fill: "#efeff8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.609,
    cy: 2.609,
    r: 2.609,
    transform: "translate(19.147 32.232)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.609,
    cy: 2.609,
    r: 2.609,
    transform: "translate(39.773 32.232)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51,327.327l-.144-.273a4.972,4.972,0,0,0-4.073-2.517,3.225,3.225,0,0,0-3.1,2.447l-.074.3-.6-.144.072-.3a3.892,3.892,0,0,1,3.7-2.918,5.52,5.52,0,0,1,4.62,2.848l.144.271Z",
    transform: "translate(-334.693 -289.46)",
    fill: "#dfdff0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.507 5.769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.543,323.64l-.043-.206c.134-.029.265-.06.4-.095l.051.206C555.808,323.581,555.679,323.611,555.543,323.64Z",
    transform: "translate(-555.5 -274.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.3,144.969l-.066-.193c.257-.088.514-.185.763-.29l.08.189C559.826,144.782,559.565,144.881,559.3,144.969Zm1.532-.656-.092-.181a8.149,8.149,0,0,0,.709-.411l.107.175A5.265,5.265,0,0,1,560.834,144.313Zm1.415-.87-.121-.167c.222-.162.436-.333.637-.508l.136.154c-.216.187-.422.362-.654.528Zm1.254-1.094-.15-.142c.189-.206.368-.411.532-.617l.162.125c-.171.226-.354.438-.541.642Zm1.018-1.316-.175-.109a5.994,5.994,0,0,0,.378-.716l.189.084a6.959,6.959,0,0,1-.395.748Zm.681-1.526L565,139.45a5.367,5.367,0,0,0,.167-.787l.206.027a5.274,5.274,0,0,1-.169.827Zm.228-1.645h-.206v-.06c0-.249-.014-.5-.039-.75l.206-.021a7.462,7.462,0,0,1,.041.771Zm-.37-1.61a8.1,8.1,0,0,0-.206-.785l.206-.062a6.907,6.907,0,0,1,.206.8Zm-.487-1.548c-.1-.243-.206-.491-.337-.742l.185-.093c.125.255.241.51.341.757Zm-.72-1.466c-.127-.224-.267-.461-.411-.7l.175-.109c.15.245.292.483.411.711Zm-.859-1.4c-.15-.226-.3-.454-.458-.683l.171-.115c.156.228.308.456.459.687Zm-.925-1.361c-.154-.226-.31-.454-.463-.681l.171-.115c.152.226.306.454.461.679Zm-.919-1.369c-.15-.23-.3-.465-.44-.7l.175-.107c.144.234.29.465.438.695Zm-.857-1.413c-.14-.249-.269-.5-.387-.732l.185-.093c.115.234.245.477.38.724Zm-.73-1.48c-.109-.257-.206-.518-.3-.773l.206-.066c.086.249.183.506.29.759Zm-.535-1.569c-.068-.267-.128-.541-.173-.822l.206-.033c.045.263.1.53.169.794Zm-.276-1.645c-.021-.253-.031-.508-.031-.763v-.068h.206v.066a6.029,6.029,0,0,0,.031.746Zm.206-1.645-.206-.021c0-.056.01-.113.016-.173.025-.22.056-.44.093-.65l.206.035c-.035.206-.066.422-.091.637a.423.423,0,0,1-.008.177Zm.286-1.6-.206-.056c.076-.271.164-.537.263-.79l.191.074a7.5,7.5,0,0,0-.239.777Zm10.246-1.2a2.571,2.571,0,0,1-.352-.033c-.16-.023-.321-.049-.479-.08l.041-.206c.152.029.31.056.467.078.111.014.224.025.333.031Zm.845-.064-.043-.206a2.374,2.374,0,0,0,.732-.284l.107.175a2.56,2.56,0,0,1-.785.321Zm-10.5-.245-.183-.1a7.3,7.3,0,0,1,.434-.711l.169.117a6.721,6.721,0,0,0-.409.7Zm8.019-.012a7.923,7.923,0,0,1-.781-.294l.084-.189a7,7,0,0,0,.759.286Zm3.907-.642-.171-.115a1.439,1.439,0,0,0,.251-.718l.206.014a1.646,1.646,0,0,1-.28.825Zm-5.428-.031a7.543,7.543,0,0,1-.7-.459l.121-.164a7.255,7.255,0,0,0,.678.444Zm-5.572-.642-.152-.138a6.949,6.949,0,0,1,.594-.586l.136.154a6.873,6.873,0,0,0-.572.576Zm4.234-.347a7.618,7.618,0,0,1-.582-.6l.154-.136a7.572,7.572,0,0,0,.565.582Zm6.693-.557a2.007,2.007,0,0,0-.479-.617l.136-.154a2.22,2.22,0,0,1,.528.676Zm-9.709-.162-.117-.169a7.937,7.937,0,0,1,.714-.434l.1.181a7.759,7.759,0,0,0-.687.428Zm1.921-.535c-.078-.111-.154-.224-.226-.341l-.267.1-.078-.189.236-.095c-.037-.062-.074-.123-.109-.185l.179-.1c.041.072.082.144.125.206q.173-.062.352-.117l.06.206c-.1.031-.206.064-.3.1a2.494,2.494,0,0,0,.206.294Zm6.647-.354a4.372,4.372,0,0,0-.617-.251l-.136-.043.06-.206.14.045a4.437,4.437,0,0,1,.641.261Zm-5.589-.368-.043-.206c.265-.06.541-.109.822-.148l.031.206c-.271.043-.541.095-.8.154Zm4.051-.111c-.257-.045-.528-.08-.806-.1l.016-.206c.286.025.563.06.822.107Zm-2.436-.119-.014-.206c.245-.014.489-.023.732-.023h.1v.206h-.1c-.232.006-.475.012-.713.029Zm-3.475-.491c-.111-.251-.206-.512-.3-.777l.206-.064c.086.259.183.514.29.759Zm-.52-1.579c-.062-.265-.113-.541-.152-.822l.206-.029c.039.271.088.541.148.8Zm-.23-1.645c-.01-.185-.016-.374-.016-.563v-.267h.206v.263c0,.185,0,.372.014.551Zm.245-1.645-.206-.021c.029-.271.068-.549.115-.822l.206.035a7.811,7.811,0,0,0-.121.812Zm.282-1.606-.206-.049c.066-.265.142-.533.226-.8l.206.064c-.093.269-.169.53-.232.79Zm.493-1.556-.191-.074c.1-.257.206-.514.331-.763l.185.09a8.044,8.044,0,0,0-.331.759Zm.707-1.466-.179-.1c.14-.236.29-.473.446-.7l.169.117c-.16.226-.306.456-.442.691Zm.927-1.339-.16-.13c.173-.206.358-.424.549-.617l.148.142a7.571,7.571,0,0,0-.543.609Zm1.119-1.184-.138-.152c.206-.183.411-.364.631-.539l.127.162c-.22.175-.43.354-.627.533Zm1.277-1.016-.117-.171c.224-.154.459-.306.7-.45l.1.175c-.239.146-.461.3-.691.45Zm1.4-.849-.1-.181c.243-.13.493-.253.744-.368l.086.187c-.261.117-.5.241-.74.366Zm1.487-.683-.076-.193c.259-.1.52-.206.779-.282l.066.206c-.261.078-.52.173-.775.273Z",
    transform: "translate(-558.058 -95.745)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.441,97.46l-.051-.206c.255-.066.411-.095.411-.095l.037.206S622.69,97.4,622.441,97.46Z",
    transform: "translate(-608.637 -94.41)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.031,88.557c-.524-1.624-4.036-1.04-3.352,1.084S627.555,90.184,627.031,88.557Z",
    transform: "translate(-609.591 -86.835)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.728,84.858c.027-.713,1.018-1.262,2.42-1.01a7.821,7.821,0,0,1,2.72,1.2,7.947,7.947,0,0,1-2.8.993C615.651,86.194,614.7,85.569,614.728,84.858Z",
    transform: "translate(-602.549 -83.786)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.889,89.28c-.728,0-1.454-.021-2.179-.043s-1.454-.06-2.179-.117c.728,0,1.456.019,2.182.041S622.165,89.221,622.889,89.28Z",
    transform: "translate(-605.57 -88.023)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.58,85.91a6.118,6.118,0,0,1,1.162.726,5.47,5.47,0,0,1-.6-.329A5.892,5.892,0,0,1,621.58,85.91Z",
    transform: "translate(-607.993 -85.473)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.2,89.57a6.678,6.678,0,0,1-1.2.777,6.672,6.672,0,0,1,1.209-.777Z",
    transform: "translate(-610.71 -88.381)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.88,87.62a1.488,1.488,0,0,1,.53.428,1.408,1.408,0,0,1-.29-.183,1.5,1.5,0,0,1-.241-.245Z",
    transform: "translate(-616.175 -86.832)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.57,97.34c.438.563,1.563.428,2.552-.6a7.914,7.914,0,0,0,1.513-2.564,7.921,7.921,0,0,0-2.856.822C620.544,95.7,620.13,96.775,620.57,97.34Z",
    transform: "translate(-607.056 -92.043)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.7,94.18c-.592.411-1.168.868-1.746,1.31s-1.143.9-1.7,1.369c.592-.411,1.168-.866,1.744-1.308S627.141,94.653,627.7,94.18Z",
    transform: "translate(-610.122 -92.043)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.58,103.107a5.876,5.876,0,0,0,.294-.617,5.516,5.516,0,0,0,.222-.65,5.692,5.692,0,0,0-.294.617A5.837,5.837,0,0,0,628.58,103.107Z",
    transform: "translate(-613.554 -98.128)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.439,99.6a6.8,6.8,0,0,0-1.439.076,6,6,0,0,0,.72,0A6.4,6.4,0,0,0,628.439,99.6Z",
    transform: "translate(-612.299 -96.343)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.93,98.08a1.469,1.469,0,0,0,.127-.321,1.555,1.555,0,1,0-.127.321Z",
    transform: "translate(-619.393 -94.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.2,87.51a.617.617,0,1,1,.4-.775A.617.617,0,0,1,637.2,87.51Z",
    transform: "translate(-619.761 -85.788)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.042,93.219a.617.617,0,1,1,.4-.777.617.617,0,0,1-.4.777Z",
    transform: "translate(-621.224 -90.323)",
    fill: "#455a64"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.b690793b4ee6703ad047ed4d0219fd01.svg";
export { ForwardRef as ReactComponent };